"use strict";

exports.__esModule = true;
exports.ChangeOperatorDialog = void 0;
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Utils = require("../../../Utils");
var _Core = require("../../Core/");
var _DeviceContext = require("../../Device/DeviceContext");
var _ManualEventsContext = require("../../Operator/ManualEventsContext");
var _User = require("../../User");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t3 in e) "default" !== _t3 && {}.hasOwnProperty.call(e, _t3) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t3)) && (i.get || i.set) ? o(f, _t3, i) : f[_t3] = e[_t3]); return f; })(e, t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var AddDialog = (0, _styledComponents["default"])(_core.Dialog).withConfig({
  displayName: "ChangeOperatorDialog__AddDialog",
  componentId: "sc-3sbda1-0"
})([".", "{border-top:1px solid rgba(0,0,0,0.1);padding-top:1rem;}.", "{overflow:auto;max-height:300px;}"], _core.Classes.DIALOG_FOOTER, _core.Classes.MENU);
var DialogBodySection = _styledComponents["default"].div.withConfig({
  displayName: "ChangeOperatorDialog__DialogBodySection",
  componentId: "sc-3sbda1-1"
})(["margin:1rem 1rem 0 1rem;"]);
var Row = _styledComponents["default"].div.withConfig({
  displayName: "ChangeOperatorDialog__Row",
  componentId: "sc-3sbda1-2"
})(["display:flex;padding:1rem 0;"]);
var ChangePartButtonGroup = (0, _styledComponents["default"])(_core.ButtonGroup).withConfig({
  displayName: "ChangeOperatorDialog__ChangePartButtonGroup",
  componentId: "sc-3sbda1-3"
})(["margin-left:1rem;"]);
var Operator = _styledComponents["default"].div.withConfig({
  displayName: "ChangeOperatorDialog__Operator",
  componentId: "sc-3sbda1-4"
})(["margin-bottom:1rem;font-weight:bold;"]);

/**
 * A dialog to increment partkind
 */
var ChangeOperatorDialog = exports.ChangeOperatorDialog = function ChangeOperatorDialog(props) {
  var label = props.label;

  // Context
  var device = _react["default"].useContext(_DeviceContext.DeviceContext);
  var _React$useContext = _react["default"].useContext(_User.UserListContext),
    users = _React$useContext.users;
  var _React$useContext2 = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext2.translate;
  var _React$useContext3 = _react["default"].useContext(_ManualEventsContext.ManualEventsContext),
    changeOperator = _React$useContext3.changeOperator;
  var _props$changeOperator = props.changeOperatorType,
    changeOperatorType = _props$changeOperator === void 0 ? "UserList" : _props$changeOperator;
  var userList = Object.values(users).filter(function (user) {
    return user.isEnabled;
  }).map(function (user) {
    return Object.assign({}, user, {
      // $FlowIgnore
      displayName: (0, _Utils.formatUserName)(user)
    });
  });

  // state
  var _useState = (0, _react.useState)([]),
    selectedOperators = _useState[0],
    setSelectedOperators = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    isChangingOperator = _useState2[0],
    setIsChangingOperator = _useState2[1];
  (0, _react.useEffect)(function () {
    if (changeOperatorType === "FreeText") {
      setSelectedOperators(props.operator ? [{
        username: props.operator || ""
      }] : []);
    } else {
      // Trim both sides: the operator saved by handleSubmit below is
      // trimmed, but a user's displayName can carry a trailing space
      // (e.g. an empty last name), so an untrimmed comparison here would
      // never match and would leave this operator un-selectable.
      var trimmedOperator = (props.operator || "").trim();
      var selectedOperator = userList.find(function (user) {
        return user.displayName.trim() === trimmedOperator;
      });
      setSelectedOperators(selectedOperator ? [selectedOperator] : []);
    }
  }, [props.operator]);
  var onClose = function onClose() {
    props.toggleDialog();
  };
  var onSelectOperator = function onSelectOperator(selectedArray) {
    setSelectedOperators(selectedArray);
  };
  var handleSubmitStop = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            _context.p = 0;
            setIsChangingOperator(true);
            _context.n = 1;
            return changeOperator(device, null);
          case 1:
            setTimeout(function () {
              setIsChangingOperator(false);
              props.toggleDialog();
            }, 2000);
            _context.n = 3;
            break;
          case 2:
            _context.p = 2;
            _t = _context.v;
            console.warn(_t);
            return _context.a(2, _t);
          case 3:
            return _context.a(2);
        }
      }, _callee, null, [[0, 2]]);
    }));
    return function handleSubmitStop() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            _context2.p = 0;
            setIsChangingOperator(true);
            _context2.n = 1;
            return changeOperator(device, (0, _Utils.formatUserName)(selectedOperators[0]).trim());
          case 1:
            setTimeout(function () {
              setIsChangingOperator(false);
              props.toggleDialog();
            }, 2000);
            _context2.n = 3;
            break;
          case 2:
            _context2.p = 2;
            _t2 = _context2.v;
            console.warn(_t2);
            return _context2.a(2, _t2);
          case 3:
            return _context2.a(2);
        }
      }, _callee2, null, [[0, 2]]);
    }));
    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();
  var operatorName = selectedOperators[0] && selectedOperators[0].username ? (0, _Utils.formatUserName)(selectedOperators[0]) : "";
  // The device's actual current operator, trimmed the same way
  // handleSubmit trims it before saving.
  var trimmedCurrentOperator = (props.operator || "").trim();
  function getUserSelector() {
    return /*#__PURE__*/_react["default"].createElement(_User.UserSelector, {
      large: true,
      selected: selectedOperators,
      items: userList,
      onSelect: function onSelect(selected) {
        onSelectOperator(selected);
      }
    });
  }
  function getFreeText() {
    return /*#__PURE__*/_react["default"].createElement(_core.InputGroup, {
      "data-testid": "FreeTextInput",
      value: selectedOperators.length ? selectedOperators[0].username : "",
      onChange: function onChange(event) {
        setSelectedOperators([{
          username: event.target.value
        }]);
      }
    });
  }
  var operatorInput = {
    FreeText: getFreeText,
    UserList: getUserSelector
  };
  return /*#__PURE__*/_react["default"].createElement(AddDialog, {
    icon: _icons.IconNames.COG,
    isOpen: props.isOpen,
    onClose: onClose,
    title: label
  }, /*#__PURE__*/_react["default"].createElement(DialogBodySection, null, /*#__PURE__*/_react["default"].createElement(Operator, null, translate("ChangeOperatorDialog.operator.title", "Operator: {operator}", {
    operator: props.operator || "-"
  })), /*#__PURE__*/_react["default"].createElement(Row, null, operatorInput[changeOperatorType](), /*#__PURE__*/_react["default"].createElement(ChangePartButtonGroup, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    large: true,
    intent: _core.Intent.PRIMARY,
    loading: isChangingOperator,
    onClick: handleSubmit,
    disabled: !operatorName.trim() || operatorName.trim() === trimmedCurrentOperator,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ChangeOperatorDialog.start.Button",
      defaultMessage: "Start"
    })
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    large: true,
    loading: isChangingOperator,
    intent: _core.Intent.PRIMARY,
    onClick: handleSubmitStop
    // Stop only needs to know whether the device currently has an
    // operator to clear - it must not depend on whether that
    // operator can be resolved to an entry in the (possibly
    // stale, filtered, or FreeText) selector above. Previously
    // this compared operatorName (the *selected* user) against
    // props.operator (the *actual* current operator), so any
    // operator that didn't exactly match a selectable entry -
    // e.g. via the trim mismatch fixed above, or a disabled/
    // deleted user - left Stop permanently disabled even though
    // there was a real operator to stop.
    ,
    disabled: !trimmedCurrentOperator,
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "ChangeOperatorDialog.stop.Button",
      defaultMessage: "Stop"
    })
  })))));
};